export class MdocsMoviesmodel{
    MovieId:number;
    Path:string;
    Title:string;
    Description:string;
    Status:boolean;
    UnitID:number;
    CreatedDate:Date;
}